<template>
  <base-layout @handleScroll="handleScroll">
    <template slot="header">
      <v-row
        no-gutters
        justify="space-between"
        class="py-3">
        <v-col
          md="4"
          cols="12"
          class="d-flex align-center select-branch">
        </v-col>
        <v-col
          md="6"
          cols="12"
          class="d-flex align-center search-product">
          <v-text-field
            v-model="searchText"
            label="Search"
            dense
            append-icon="mdi-magnify"
            @input="searchProduct(true, $event)" />
        </v-col>
      </v-row>
    </template>

    <productList
      :products="products"
      @onAddtoCart="addToCart" />

    <v-btn
      link
      :to="{ name: 'Cart' }"
      icon
      class="shopping-bag">
      <v-badge
        :content="amountItem"
        :value="amountItem !== 0"
        color="red"
        overlap>
        <img
          src="@/assets/image/shopping-bag.png"
          alt="shopping-bag"
          class="d-block"
          width="30"
          height="30">
      </v-badge>
    </v-btn>
  </base-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProductProvider from '@/resources/product.service'
import productList from '../components/product-list.vue'

const productService = new ProductProvider()

export default {
  components: {
    productList
  },
  data () {
    return {
      searchText: '',
      products: [],
      page: 1,
      perPage: 15,
      getting: false,
      isLoadComplete: false,
      searchTimeout: undefined
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'Warehouse/warehouse',
      selectedWarehouse: 'Warehouse/selectedWarehouse',
      amountItem: 'Order/amountItem',
      isEditBill: 'Order/isEditBill'
    }),
    search () {
      return this.$route.query.search ? this.$route.query.search : ''
    }
  },
  watch: {
    search () {
      this.loadProduct()
    },
    selectedWarehouse () {
      this.searchProduct()
      this.loadProduct()
    }
  },
  async created () {
    this.$router.replace({
      name: 'Product',
      query: {
        search: this.$route.query.search ? this.$route.query.search : ''
      }
    }).catch(() => {})
    this.searchText = this.search
    await this.loadProduct()
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setLoading: 'Style/setLoading',
      addItem: 'Order/addItem'
    }),
    addToCart (productSku) {
      const campWarehouse = this.warehouses.find((w) => w.sellsukiWarehouse === this.selectedWarehouse)
      this.addItem({
        ...productSku,
        warehouse: this.selectedWarehouse,
        campWarehouse: campWarehouse.campWarehouse
      })
    },
    searchProduct (isWait = false, txt) {
      this.isLoadComplete = false
      this.page = 1
      this.getting = false
      this.products = []
      if (isWait) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => {
          this.$router
            .push({
              name: 'Product',
              query: { search: txt } })
            .catch(() => {})
        }, 1500)
      } else {
        this.$router
          .push({
            name: 'Product',
            query: { search: this.search } })
          .catch(() => {})
      }
    },
    async loadProduct () {
      if (this.getting || this.isLoadComplete) {
        return
      }
      this.getting = true
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'Getting Products.'
        })
        const { data } = await productService.getProducts(this.page++, this.perPage, this.search, this.selectedWarehouse)
        if (data.length < this.perPage) {
          this.isLoadComplete = true
        }
        this.products.push(...data)
      } catch (error) {
        this.setSnackBar({
          value: true,
          message: 'Something went wrong.',
          type: 'error'
        })
      } finally {
        this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting Order.'
        })
      }
      this.getting = false
    },
    handleScroll (e) {
      const scrollY = e.scrollHeight - e.clientHeight - 500
      if (e.scrollTop >= scrollY && !this.getting) {
        this.loadProduct()
      }
    }
  }
}
</script>

<style>
.search-product .v-text-field__details,
.select-branch .v-text-field__details {
  display: none;
}
.v-btn--icon.shopping-bag {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  border-radius: 0;
  padding: 10px 15px;
  box-shadow: 0px -1px 10px 0px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  height: initial;
}
.shopping-bag * {
  transition: all 0.1s;
}
.shopping-bag:active>* {
  transform: scale(1.2);
}
.shopping-bag-row {
  position: relative;
}
@media screen and (min-width: 600px) {
  .v-btn--icon.shopping-bag {
    left: unset;
    bottom: 25px;
    right: 25px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    padding: 15px 15px;
    box-shadow: 1px 1px 7px 2px rgba(0, 0, 0, 0.5);
  }
}
</style>
